let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cfi6w")).then(() => parcelRequire('cUJcf'));